export enum TypeConsentStatus {
  Pending = 0,
  Filled = 1,
  SignedByPatient = 2,
  SignedByAuthorized = 3,
  Completed = 4,
}
